import { RealEmailService } from './realEmailService';

export interface ContactFormData {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  message: string;
}

export interface FormValidation {
  isValid: boolean;
  errors: string[];
}

export interface FormResponse {
  success: boolean;
  message: string;
}

// Validación de email
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validación de teléfono (formato argentino)
export const isValidPhone = (phone: string): boolean => {
  const phoneRegex = /^(\+54\s?)?(9\s?)?[0-9]{2}\s?[0-9]{4}\s?[0-9]{4}$/;
  return phoneRegex.test(phone.replace(/\s/g, ''));
};

// Validación del formulario
export const validateForm = (data: ContactFormData): FormValidation => {
  const errors: string[] = [];

  if (!data.firstName.trim()) {
    errors.push('El nombre es requerido');
  }

  if (!data.lastName.trim()) {
    errors.push('El apellido es requerido');
  }

  if (!data.email.trim()) {
    errors.push('El email es requerido');
  } else if (!isValidEmail(data.email)) {
    errors.push('El formato del email no es válido');
  }

  if (data.phone.trim() && !isValidPhone(data.phone)) {
    errors.push('El formato del teléfono no es válido (formato argentino)');
  }

  if (!data.message.trim()) {
    errors.push('El mensaje es requerido');
  } else if (data.message.length < 10) {
    errors.push('El mensaje debe tener al menos 10 caracteres');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

// Formatear número de teléfono
export const formatPhoneNumber = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `+54 9 ${cleaned.slice(0, 2)} ${cleaned.slice(2, 6)} ${cleaned.slice(6)}`;
  }
  return phone;
};

// Enviar formulario usando el servicio de email real
export const sendFormData = async (data: ContactFormData): Promise<FormResponse> => {
  try {
    console.log('📧 Enviando email usando servicio real...');
    
    // Usar el servicio de email real que funciona automáticamente
    const result = await RealEmailService.sendEmail(data);
    
    return result;
  } catch (error) {
    console.error('Error al enviar email:', error);
    return {
      success: false,
      message: 'Error al enviar el mensaje. Por favor, intenta nuevamente.'
    };
  }
};

// Función de respaldo (simulación) para desarrollo
export const sendFormDataFallback = async (data: ContactFormData): Promise<FormResponse> => {
  // Simular envío para desarrollo
  await new Promise(resolve => setTimeout(resolve, 2000));
  
  console.log('📧 Email simulado enviado:', {
    to: 'openwebstudios@gmail.com',
    from: 'ramiromunoz@myportfolio-rm.com',
    subject: `Nuevo mensaje de ${data.firstName} ${data.lastName}`,
    body: `
      Nombre: ${data.firstName} ${data.lastName}
      Email: ${data.email}
      Teléfono: ${data.phone || 'No proporcionado'}
      Mensaje: ${data.message}
    `
  });

  return {
    success: true,
    message: '¡Mensaje enviado exitosamente! Te contactaremos pronto.'
  };
}; 